import classNames from 'classnames'
import React, {PropsWithChildren} from 'react'
import {Button, HoverStyles} from 'wix-ui-tpa/cssVars'
import {useColors} from '../../../../hooks/colors'
import {StyledButtonProps} from './interfaces'
import {classes} from './styled-button.st.css'

export const StyledButton = ({
  dataHook,
  onClick,
  children,
  disabled = false,
  fullWidth = true,
  secondary = false,
  className,
  small = false,
}: PropsWithChildren<StyledButtonProps>) => {
  const {darkColor} = useColors()

  const getClassName = () => {
    if (secondary && !darkColor) {
      return classes.secondaryDark
    }
    if (secondary) {
      return classes.secondary
    }
    if (!darkColor) {
      return classes.regularDark
    }
    return classes.regular
  }

  return (
    <Button
      data-hook={dataHook}
      fullWidth={fullWidth}
      upgrade
      className={classNames(classes.button, getClassName(), className, {[classes.small]: small})}
      onClick={onClick}
      disabled={disabled}
      hoverStyle={HoverStyles.underline}
    >
      {children}
    </Button>
  )
}
